import React, { useState } from "react";
import { Star } from "lucide-react";
import { reviewsAPI } from "../../api";
import "./Reviews.css";

const ReviewForm = ({ orderId, reviewedUserId, onSuccess, onCancel }) => {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (rating === 0) {
      setError("Veuillez sélectionner une note");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      const reviewData = {
        reviewed_user_id: reviewedUserId,
        rating: rating,
        comment: comment.trim() || null,
        order_id: orderId || null,
      };

      await reviewsAPI.create(reviewData);
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors de la création de l'avis");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="review-form-container">
      <h3>Laisser un avis</h3>
      
      {error && <div className="alert alert-error">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Note *</label>
          <div className="star-rating">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                type="button"
                className={`star-button ${star <= (hoveredRating || rating) ? "active" : ""}`}
                onClick={() => setRating(star)}
                onMouseEnter={() => setHoveredRating(star)}
                onMouseLeave={() => setHoveredRating(0)}
                disabled={submitting}
              >
                <Star
                  size={26}
                  strokeWidth={1.75}
                  color="var(--warning)"
                  fill={star <= (hoveredRating || rating) ? "var(--warning)" : "none"}
                />
              </button>
            ))}
            {rating > 0 && (
              <span className="rating-text">
                {rating === 1 && "Très mauvais"}
                {rating === 2 && "Mauvais"}
                {rating === 3 && "Moyen"}
                {rating === 4 && "Bien"}
                {rating === 5 && "Excellent"}
              </span>
            )}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Commentaire (optionnel)</label>
          <textarea
            className="form-control"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            rows="4"
            placeholder="Partagez votre expérience..."
            disabled={submitting}
          />
        </div>

        <div className="review-form-actions">
          {onCancel && (
            <button
              type="button"
              className="btn btn-outline"
              onClick={onCancel}
              disabled={submitting}
            >
              Annuler
            </button>
          )}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={submitting || rating === 0}
          >
            {submitting ? "Envoi..." : "Publier l'avis"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReviewForm;

